import { Store } from "pullstate";
export default new Store({
  fcmToken: "",
  RNfcmToken: "",
  user: {},
  userInfo: null,
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false
  },
  isAddPatientOpen: false,
  isEditPatientOpen: false,
  isLogoutOpen: false,
  sharingPatient: "",
  isGetFullAccessOpen: true,
  enableViewerAPICall: true,
  enableSidebarAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isExportDataOpen: false,
  isStartingDownload: false,
  isChangeRegionModalOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedConditionOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false,
  hasUpdatedStudy: false,
  isRemoteAccessOpen: false,
  showMobileReport: false,
  isQXRModality: false,
  addPhoneModal: false,
  hasLicenseExpiredForSelectedPatient: false,
  isSettingsOpen: false,
  hasUnsavedSetting: false,
  selectedSetting: "",
  settingPageNo: 0,
  settingParams: {},
  showUnsavedWarning: false,
  isDiskSpaceWarning: false,
  patientsFileDeletionStatus: "",
  worklistSyncStatus: {},
  worklistCloudSyncStatus: {},
  isqTrack: false,
  selectedPatient: null,
  isTestSetModalOpen: false,
  testSetModalData: {},
  testModalResult: false
});